module.exports = __webpack_public_path__ + "img/wangxiao_prod.c458aada.png";